<template>
    <b-form-input
        @input="onTyping"
        v-model="value"
        :placeholder="placeholder"
    />
</template>

<script>
import {BFormInput} from 'bootstrap-vue'
export default {
    components: {
        BFormInput
    },
    props: {
        placeholder: {
            default() {
                return this.$t('Component(Placeholder):type-here');
            }
        }
    },
    data() {
        return {
            timer: null,
            value: ''
        };
    },
    methods: {
        onTyping(value) {
            if (this.timer) {
                clearTimeout(this.timer);
            }

            this.timer = setTimeout(() => {
                this.$emit('search', value);
            }, 500);
        }
    }
}
</script>

<style scoped>

</style>
